module.exports = __webpack_public_path__ + "img/model_exam.4bdb0469.png";